// removed by extract-text-webpack-plugin
module.exports = {"pageWrapper":"pageWrapper__3i1j2","campaignLandingPageContainer":"campaignLandingPageContainer__6JlGj","instacredHeaderLogo":"instacredHeaderLogo__IkIVk","instacredHeaderLogoWhite":"instacredHeaderLogoWhite__1avIg","footer":"footer__3ixY8","footerLinks":"footerLinks__olb3Y","flexmoneyBranding":"flexmoneyBranding__Fybag","errorMessageContainer":"errorMessageContainer__IB5HQ","merchantHeight":"merchantHeight__1uoL5","merchantBenefitsHeight":"merchantBenefitsHeight__2KM1h","footerLinksContainer":"footerLinksContainer__17Tql"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/stylesVC/style.css
// module id = 9zet
// module chunks = 459